class BESSAppNewProjectComponent extends BESSAppComponent {

    constructor() {
        super('.app-new-project');
    }

    setupComponent(componentNode) {
        componentNode.bindClickEvent(this, this.#onStartNewProject);
    }

    #onStartNewProject() {
        let profiler = BESSApp.instance.managers.profilers.getProfiler('BESSAppNewProjectEditor');
        new BESSAppProjectEditorModal(profiler, false).open();
    }
}